import { render, staticRenderFns } from "./SAutocomplete.vue?vue&type=template&id=64c4a15e&scoped=true"
import script from "./sAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./sAutocomplete.ts?vue&type=script&lang=ts&external"
import style0 from "./SAutocomplete.vue?vue&type=style&index=0&id=64c4a15e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4a15e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c4a15e')) {
      api.createRecord('64c4a15e', component.options)
    } else {
      api.reload('64c4a15e', component.options)
    }
    module.hot.accept("./SAutocomplete.vue?vue&type=template&id=64c4a15e&scoped=true", function () {
      api.rerender('64c4a15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/filter/s-autocomplete/SAutocomplete.vue"
export default component.exports